export const API_PATH = 'acpl/ai-alt-generator';
export const BULK_ACTION_OPTION_VALUE = 'generate_alt_text';
